import { render, staticRenderFns } from "./newsPage10.vue?vue&type=template&id=262b0f50&scoped=true&"
import script from "./newsPage10.vue?vue&type=script&lang=js&"
export * from "./newsPage10.vue?vue&type=script&lang=js&"
import style0 from "./newsPage10.vue?vue&type=style&index=0&id=262b0f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262b0f50",
  null
  
)

export default component.exports